<template>
    <div class="page">
      <h2 class="heading" style="margin-top: 110px;">Videos</h2>
  
      <VideoPageGrid :videos="videos" />
  
      <PaginationComponent
          :current="currentPage"
          :pages="pages"
          @change="changePage"
          @next="nextPage"
      />
    </div>
  </template>
  
  <script>
  import VideoPageGrid from "@/components/VideoPageGrid.vue";
  import PaginationComponent from "@/components/PaginationComponent.vue";

  export default {
    components: { VideoPageGrid, PaginationComponent },
    
    data() {
      return {
        perPage: 24,
        videos: [],
        escort_video: []
      };
    },

    computed: {
        // 🔹 Total pages
        totalPages() {
          return Math.ceil(this.videos.length / this.perPage);
        },

        // 🔹 Page numbers array [1,2,3...]
        pages() {
          return Array.from({ length: this.totalPages }, (_, i) => i + 1);
        },

        // 🔹 Slice profiles for current page
        paginatedProfiles() {
          const start = (this.currentPage - 1) * this.perPage;
          const end = start + this.perPage;
          return this.profiles.slice(start, end);
        }
      },
      async mounted(){
        this.user_email = localStorage.getItem("email");
        this.userId = localStorage.getItem("userid"); 

        await this.listEscortVideos()
      },

    methods: {
      onPageChange(page) {
        console.log("Page:", page);
      },
      onNext() {
        console.log("Next page");
      },

      async listEscortVideos(){
        try{

            const response = await this.$http.get('/list-all-free-videos',{} )
            this.escort_video = response.data.data;

           // Map API data to ProfileGrid format
            this.videos = this.escort_video.map(r => ({
            title: r.description,
            file_path:  r.file_path,
            thumbnail:  r.thumbnail_path,
            is_premium: r.is_premium,
            price: r.price,
            locked: r.is_premium !== "free",
            views: r.likes,
            duration: r.video_duration,
            link: `/escort-profile/${r.escort_id}/${r.username}`,
            }));
            this.currentPage = 1; // reset page on reload

            }catch (err) {
            console.log(err);
        }
      },

       // 🔹 Pagination actions
      changePage(page) {
        this.currentPage = page;
        window.scrollTo({ top: 0, behavior: "smooth" });
      },

      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      },

    }
  };
  </script>
  
  <style scoped>
  .page {
    margin-top: 70px;
    background: #0b0b14;
    min-height: 100vh;
    padding: 0px;
    color: #fff;
  }
  
  .heading {
    margin-bottom: 20px;
    color: #D33E74;
  }
  </style>
  